import { Language, Subsidiary } from '@coolblue-development/constants';
import { formatCurrency } from '@coolblue-development/next-formatting-utils/core';
import { InsuranceAttribute, InsuranceLiability } from '@features/product/typings';

export function replaceInsuranceAttributePlaceholders(
  attribute: InsuranceAttribute,
  liability: InsuranceLiability,
  language: Language,
  subsidiary: Subsidiary
): InsuranceAttribute {
  const formattedDamageAmount = liability.damage
    ? formatCurrency({ amount: liability.damage, language, subsidiary })
    : '';
  const formattedTheftAmount = liability.theft
    ? formatCurrency({ amount: liability.theft, language, subsidiary })
    : '';

  return {
    ...attribute,
    name: attribute.name
      .replaceAll('{liability_damage}', formattedDamageAmount)
      .replaceAll('{liability_theft}', formattedTheftAmount),
    description: attribute.description
      .replaceAll('{liability_damage}', formattedDamageAmount)
      .replaceAll('{liability_theft}', formattedTheftAmount)
  };
}
